import { createSelector } from '@reduxjs/toolkit';
import { availableFilters } from './CustomerList/lib';
import { selectIsViewAggregated } from 'pages/Organization/selectors';

export const selectAvailableFilters = createSelector(
  ({ customers }) => customers,
  selectIsViewAggregated,
  ({ filters }, isViewAggregated) => {
    const filteredAvailableFilters = isViewAggregated
      ? availableFilters
      : availableFilters.filter(({ type }) => type !== 'parent-organization-filter');

    return filteredAvailableFilters.filter(
      ({ type }) => !filters.some((filter) => filter.type === type),
    );
  },
);

export const selectFilters = createSelector(
  ({ customers }) => customers,
  ({ filters }) => filters,
);
